import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Box from '@material-ui/core/Box';
import Spinner from 'components/UI/Spinner';
import Button from 'components/UI/Buttons/BaseButton';

import { useAppDispatch } from '../../../app/hooks/useAppDispatch';
import { useAppSelector } from '../../../app/hooks/useAppSelector';
import {
  fetchProformaInvoiceTempLink,
  selectProformaInvoiceTempLink,
} from '../../../slices/proformaInvoicesSlice/proformaInvoicesSlice';
import styles from './InvoiceDrawer.module.css';

// Temporary link to the invoice PDF, as in the former read-only details view.
export default function InvoicePdfLink({ uuid }: { uuid: string }) {
  const { t } = useTranslation('proforma-invoices-page');
  const dispatch = useAppDispatch();
  const tempLink = useAppSelector(selectProformaInvoiceTempLink(uuid));
  const [loading, setLoading] = useState(false);

  const onGetLink = async () => {
    setLoading(true);
    try {
      const { link } = await dispatch(fetchProformaInvoiceTempLink(uuid)).unwrap();
      await navigator.clipboard.writeText(link);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={styles.pdfLink}>
      <Button variant="outlined" onClick={onGetLink} disabled={loading}>
        {loading ? <Spinner size={20} /> : t('getTemporaryLink')}
      </Button>
      {tempLink && (
        <a className={styles.link} href={tempLink} target="_blank" rel="noopener noreferrer">
          {t('viewProforma')}
        </a>
      )}
    </Box>
  );
}
